import { URLS } from '../../router-x/urls';

export const managementBranchUrl = (branchId) => `${URLS.ADMIN.MANAGEMENT}/${branchId}`;

export const managementBuildingUrl = (branchId, buildingId) =>
  `${URLS.ADMIN.MANAGEMENT}/${branchId}/${buildingId}`;

export const managementFloorUrl = (branchId, buildingId, floorId) =>
  `${URLS.ADMIN.MANAGEMENT}/${branchId}/${buildingId}/${floorId}`;

export const managementFloorEditUrl = (branchId, buildingId, floorId) =>
  `${managementFloorUrl(branchId, buildingId, floorId)}/edit`;

export const managementFloorHistoryUrl = (branchId, buildingId, floorId) =>
  `${managementFloorUrl(branchId, buildingId, floorId)}/history`;
